<div class="site-wrapper">
  <ng-container *ngIf="useRebranded; else legacyHeader">
    <app-header-v2 />
  </ng-container>

  <ng-template #legacyHeader>
    <app-header></app-header>
  </ng-template>

  <div class="page-content">
    <router-outlet></router-outlet>
  </div>

  <ng-container *ngIf="useRebranded; else legacyFooter">
    <app-footer-v2 />
  </ng-container>

  <ng-template #legacyFooter>
    <app-footer></app-footer>
  </ng-template>
</div>

<div class="d-none">VERSION: {{ appVersion }}</div>
